<template>
  <HeadingLv1 text="病院見学申込み内容のご確認" />
  <div class="u-containar">
    <MypageContents>
      <Loader v-if="loading" />

      <template v-if="!loading">
        <HeadingLv3 text="申込み先病院情報" />
        <Button
          class="linkTo"
          v-if="detail.activeFlag === 3"
          label="詳細"
          :handleClick="
            () => {
              $router.push(detail.link)
            }
          "
        />
        <Button class="linkTo" v-else disabled label="掲載終了" />
        <PreviewPairData
          v-for="(item, i) in detail.hospitalInfo"
          class="-mypage"
          :key="i"
          :label="item.label"
          :content="item.content"
        />

        <HeadingLv3 text="希望する内容" class="mypageMargin" />
        <PreviewPairData
          v-for="(item, i) in detail.entryData"
          :key="i"
          :label="item.label"
          :content="item.content"
          hideEmptyContent
        />

        <p class="note">
          ＊当サイトから見学予約のキャンセルは行なえません。キャンセルをご希望される方は、見学先の病院の担当者へ直接ご連絡をしてください。
        </p>
        <BackTo :link="detail.backLink" />
      </template>
    </MypageContents>
  </div>
</template>

<script lang="ts">
import { onMounted, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import BackTo from '@/components/block/BackTo.vue'
import Loader from '@/components/elements/Loader.vue'

export default defineComponent({
  name: 'mypageVisitApplicationDetail',

  props: {
    detail: Object,
    loading: {
      type: Boolean,
      default: true
    }
  },

  components: {
    HeadingLv1,
    MypageContents,
    HeadingLv3,
    Button,
    PreviewPairData,
    BackTo,
    Loader
  },

  setup(props, context) {
    const route = useRoute()
    onMounted(() => {
      const id = route.params.id
      if (id.indexOf('_') == -1) {
        context.emit('get-detail-page', id)
      } else {
        const hospitalID = (id as string).split('_')[0]
        context.emit('get-detail-page-s', hospitalID)
      }
    })
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';

::v-deep(.headingLv3) {
  margin-bottom: 16px;
}

.mypageMargin {
  margin-top: 40px;
  @include mixins.media() {
    margin-top: 50px;
  }
}

.u-containar {
  position: relative;
}

.linkTo {
  height: 40px;
  width: 72px;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  box-shadow: 0 3px 6px rgba($color: #000, $alpha: 0.08);
  position: absolute;
  right: 16px;
  top: 50px;
  padding: 0;
  margin: 0;
  @include mixins.media() {
    top: 35px;
    left: 67%;
  }
  &:disabled {
    width: 84px;
    @include mixins.media() {
      left: 65.5%;
    }
  }
}

.note {
  margin-top: 16px;
  margin-bottom: 30px;
  margin-left: 1em;
  text-indent: -1em;
  line-height: 1.5;
  font-size: 1.2rem;
}
</style>
